var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('detection-detail-link',{attrs:{"detail-layout":_vm.detailLayout,"detectionData":_vm.detectionData}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }